;jQuery(function () {

    jQuery('#partners .slick').slick({
        slidesToShow   : 6,
        slidesToScroll : 1,
        autoplay       : true,
        autoplaySpeed  : 2000,
        infinite       : true,
        arrows         : false,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            },
        ],
    });

});